export default __webpack_public_path__ + "static/media/twitter_logo.1d80af4d.svg";